import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as SendInternalSMSActionMetadataKeys from 'automation-ui-action-features/actions/send-internal-sms/constants/SendInternalSMSActionMetadataKeys';
export default class SendInternalSMSActionMetadata extends Record({
  [SendInternalSMSActionMetadataKeys.ACTION_TYPE]: ActionTypes.SEND_SMS_NOTIFICATION,
  [SendInternalSMSActionMetadataKeys.STATIC_TO]: null,
  [SendInternalSMSActionMetadataKeys.TO_PROPERTY]: null,
  [SendInternalSMSActionMetadataKeys.USER_ID]: null,
  [SendInternalSMSActionMetadataKeys.BODY]: null
}, 'SendInternalSMSActionMetadata') {}